import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import Swal from "sweetalert2";

import { CircularProgress } from "@mui/material";
import {
  customerservice,
  loanManagementUrl,
  setupManagementUrl,
} from "../../../config";
import {
  executeAnyMutation,
  fetchJsonDynamic,
  fetchJson,
} from "../../../data/DynamicServiceNew/jsondynamicservice";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import { tokens } from "../../../theme";
import { useTheme } from "@emotion/react";

const ReBookLoanUI = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  // const customersData = [
  //   { id: '36991073', name: 'Lilian Kilani', email: 'fulusi@gmail.com', phone: '0798706353', branch: 'Kitengela', loanLimit: 3000, createdAt: 'Nov 29, 2021' },
  //   // Add more customer data as needed
  // ];
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCustomer, setFilteredCustomer] = useState(null);
  const [amount, setAmount] = useState("");
  const [loanProductSelected, setLoanProductSelected] = useState([]);
  const [noOfInstallments, setNoOfInstallments] = useState(null);
  const [installmentError, setInstallmentError] = useState("");
  const [loanProduct, setLoanProduct] = useState("");
  const [selectedLoanProduct, setSelectedProduct] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const resetForm = () => {
    setSearchTerm("");
    setFilteredCustomer(null);
    setAmount("");
    setLoanProductSelected("");
  };

  const handlesearch = async () => {
    setLoadingSearch(true); // Start loading

    try {
      const mutationdata = { searchParameter: searchTerm };

      // Perform API call to search customer
      const customer = await fetchJson({
        objectName: "searchCustomerForLoanRebooking",
        inputObjectName: "searchCustomerforLoanRebooking",
        params: mutationdata,
        baseUrl: customerservice.uri,
      });

      if (JSON.parse(customer.results) === null) {
        Swal.fire("Customer Not Found", "Customer does not exist", "warning");
      }
      setFilteredCustomer(JSON.parse(customer.results) || null); // Update state with customer data
    } catch (error) {
      console.error("Search error:", error);
      Swal.fire(
        "Search Failed",
        "An error occurred during the search. Please try again later.",
        "error"
      );
    } finally {
      setLoadingSearch(false); // End loading after search is completed
    }
  }; // Short debounce delay for a smoother typing experience

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      const params = { companyId: companyId };
      const productResponse = await fetchJsonDynamic(
        "allProductsByColumnValues",
        "parameters",
        params,
        setupManagementUrl.uri
      );
      const allProducts = JSON.parse(productResponse.results) || []; // Filter regions based on selected company ID

      setLoanProduct(allProducts);
    };
    fetchData();
  }, []);

  useEffect(() => {
    setFilteredCustomer(null);
    const isValidPhoneNumber = /^(254|07|01)\d{8,10}$/.test(searchTerm);
    if (isValidPhoneNumber) {
      handlesearch(searchTerm);
    } else if (searchTerm.length > 4) {
      handlesearch(searchTerm);
    }
  }, [searchTerm]);

  // Extract MessageText using a regular expression
  const extractMessageText = (errorString) => {
    const match = errorString.match(/MessageText:\s*(.+)/);
    return match ? match[1].trim() : "MessageText not found";
  };
  // Extract only the "Error" part
  const extractError = (errorString) => {
    const match = errorString.match(/Error: (.+?)\\n/);
    return match ? match[1] : "Error not found";
  };
  const handleAppraisalSubmit = async () => {
    setLoadingSubmit(true); // Start loading when the form is submitted

    try {
      const mutationData = {
        p_customerid: filteredCustomer.customer_id,
        p_principle: parseInt(amount) || null,
        p_productid: loanProductSelected,
        p_Installment: parseInt(noOfInstallments) || null,
      };

      const response = await executeAnyMutation(
        "rebookLoan",
        mutationData,
        "loanRebooking",
        false,
        loanManagementUrl.uri
      );
      if (response.results !== null) {
        const parsedResults = JSON.parse(response.results);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Loan Re-booked Successfully!",
        });
        // Reset form upon successful submission
        await handlesearch();
      } else {
        const messageText = extractError(extractMessageText(response.error));
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: `${messageText}`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
      resetForm();
    } finally {
      setLoadingSubmit(false); // End loading after the process
    }
  };
  const date = new Date();
  const formatter = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h5">Re-Book Loan</Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <TextField
            label="Search Customer by Customer Phone Number"
            placeholder="Enter search criteria"
            variant="outlined"
            fullWidth
            margin="normal"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: loadingSearch && (
                <CircularProgress size={24} sx={{ marginRight: 2 }} />
              ),
            }}
          />
        </Grid>
        {/* <Grid item xs={3}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handlesearch}
            disabled={loadingSearch}
          >
            Search
          </Button>
        </Grid> */}
      </Grid>

      {filteredCustomer && (
        <>
          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent sx={{ bgcolor: `${colors.primary[200]}` }}>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Customer Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Customer Name:</strong>{" "}
                    {filteredCustomer.customer_name}
                  </Typography>
                  <Typography>
                    <strong>Email:</strong> {filteredCustomer.email_address}
                  </Typography>
                  <Typography>
                    <strong>ID Number:</strong>{" "}
                    {filteredCustomer.id_or_passport}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Mobile Number:</strong>{" "}
                    {filteredCustomer.mobile_number}
                  </Typography>
                  <Typography>
                    <strong>Branch:</strong> {filteredCustomer.branch_name}
                  </Typography>
                  <Typography>
                    <strong>Date Created:</strong>{" "}
                    {formatter.format(new Date(filteredCustomer.date_created))}
                  </Typography>
                  <Typography>
                    <strong>Current Loan Limit:</strong>{" "}
                    {filteredCustomer.loan_limit || "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent sx={{ bgcolor: `${colors.primary[200]}` }}>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Old Loan Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Loan Product:</strong>{" "}
                    {filteredCustomer.product_name || "N/A"}
                  </Typography>
                  <Typography>
                    <strong>Amount To Disburse:</strong>{" "}
                    {filteredCustomer.amount_to_disburse}
                  </Typography>
                  <Typography>
                    <strong>Loan Amount:</strong> {filteredCustomer.loan_amount}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Loan Balance:</strong>{" "}
                    {filteredCustomer.loan_balance}
                  </Typography>
                  <Typography>
                    <strong>Borrow Date:</strong>{" "}
                    {formatter.format(new Date(filteredCustomer.borrow_date))}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent sx={{ bgcolor: `${colors.primary[200]}` }}>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Loan Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Loan Product</InputLabel>
                    <Select
                      value={loanProductSelected}
                      onChange={(e) => {
                        const value = e.target.value;
                        setLoanProductSelected(value);
                        const selected = loanProduct.find(
                          (product) => product.Id === value
                        );
                        setSelectedProduct(selected);
                      }}
                      defaultValue=""
                    >
                      <MenuItem value="" disabled>
                        Select Loan Product
                      </MenuItem>
                      {loanProduct.map((company) => (
                        <MenuItem key={company.Id} value={company.Id}>
                          {company.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Amount to Disburse"
                    placeholder="Enter Amount"
                    required
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    error={!amount}
                    helperText={!amount ? "Amount to Disburse is required" : ""}
                  />
                </Grid>
              </Grid>
              {/* Show No of Installments only if IsDynamicInstallment === 1 */}
              {selectedLoanProduct.IsdynamicInstallment === 1 && (
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Minimum Installment"
                      value={selectedLoanProduct.MinimumTerm || ""}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Maximum Installment"
                      value={selectedLoanProduct.MaximumTerm || ""}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="No of Installments"
                      placeholder="Enter Number of Installments"
                      value={noOfInstallments}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Only check if it's a valid number (not empty or numeric)
                        if (value === "" || /^\d*$/.test(value)) {
                          setNoOfInstallments(value);
                          setInstallmentError(""); // Clear error when user types
                        }
                      }}
                      error={!!installmentError}
                      helperText={
                        installmentError ||
                        `Enter between ${selectedLoanProduct.MinimumTerm} and ${selectedLoanProduct.MaximumTerm}`
                      }
                    />
                  </Grid>
                </Grid>
              )}
            </CardContent>
          </Card>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleAppraisalSubmit}
            disabled={loadingSubmit} // Disable button when loading
          >
            {loadingSubmit ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit For Appraisal"
            )}
          </Button>
        </>
      )}
    </Box>
  );
};

export default ReBookLoanUI;
